import { useState, useEffect } from 'react';
import '../../../entrydoor.css';

const OPTIONS = [
  { value: '4 5/8" x 1 1/4"', label: '4 5/8" x 1 1/4"' },
  { value: '5 1/2" x 1 1/4"', label: '5 1/2" x 1 1/4"' },
  { value: '6 5/8" x 1 1/4"', label: '6 5/8" x 1 1/4"' },
  { value: '8 1/4" x 1 1/4"', label: '8 1/4" x 1 1/4"' },
];

const Jambs = ({ value = { value: '', label: '' }, onChange, disabled = false }) => {
  const [selected, setSelected] = useState(value?.value || '');

  useEffect(() => { setSelected(value?.value || ''); }, [value?.value]);

  const handleChange = (e) => {
    const v = e.target.value;
    const label = OPTIONS.find(o => o.value === v)?.label || v;
    setSelected(v);
    onChange({ value: v, label });
  };

  return (
    <div className="a-container">
      <label htmlFor="SdJambs">Jambs</label>
      <select id="SdJambs" value={selected} onChange={handleChange} disabled={disabled}>
        {OPTIONS.map(o => (
          <option key={o.value} value={o.value}>
            {selected === o.value ? `${o.label} ✔` : o.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default Jambs;
